import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './Header.css';
import * as helpers from '../helpers/helpers';
import FloatingMenu, { FloatingMenuItem } from '../helpers/FloatingMenu.jsx';
import { Item as MenuItem } from 'rc-menu';
import { ReactComponent as BurgerMenuIcon } from './images/burger-menu.svg';
import Portal from '../helpers/Portal.jsx';

const feedbackTemplate = (
  url,
  xmin,
  xmax,
  ymin,
  ymax,
  centerx,
  centery,
  scale
) =>
  `${url}/?xmin=${xmin}&xmax=${xmax}&ymin=${ymin}&ymax=${ymax}&centerx=${centerx}&centery=${centery}&scale=${scale}`;

const Header = (props) => {
  const [logoImage, setLogoImage] = useState('');

  const test = '';
  // listener for feedback
  // window.emitter.addListener('feedback', () => onFeedbackClick());

  // ON LOGO IMAGE CHANGE
  useEffect(() => {
    window.emitter.emit('headerLoaded');
    helpers.addIsLoaded('header');
  }, [logoImage]);

  // ON LOAD
  useEffect(() => {
    helpers.waitForLoad('settings', Date.now(), 30, () => {
      setLogoImage(window.config.headerLogoImageName);
    });
  }, []);

  // BURGER BUTTON HANDLER
  const burgerButtonHandler = () => {
    helpers.waitForLoad('map', Date.now(), 30, () => {
      // EMIT A CHANGE IN THE SIDEBAR (IN OR OUT)
      if (window.sidebarOpen)
        window.emitter.emit('setSidebarVisiblity', 'CLOSE');
      else window.emitter.emit('setSidebarVisiblity', 'OPEN');

      helpers.addAppStat('Burger Button', 'Click');
    });
  };

  // DOT MENU HANDLER
  const onDotMenuClick = (evt) => {
    var evtClone = Object.assign({}, evt);
    const menu = (
      <Portal>
        <FloatingMenu
          key={helpers.getUID()}
          buttonEvent={evtClone}
          item={props.info}
          onMenuItemClick={onMenuItemClick}
          styleMode="left"
        >
          <MenuItem
            className="fs-floating-menu-toolbox-menu-item"
            key="fs-floating-menu-login"
          >
            <FloatingMenuItem imageName={'lock.png'} label="Login (Sample)" />
          </MenuItem>
        </FloatingMenu>
      </Portal>
    );
    ReactDOM.render(menu, document.getElementById('portal-root'));

    helpers.addAppStat('Header Dot Menu', 'Click');
  };

  // DOT MENU ITEM CLICK
  const onMenuItemClick = (value) => {
    helpers.showMessage('Coming Soon', 'Coming Soon...');
    helpers.addAppStat('Header Dot Menu', value);
  };

  return (
    <div
      className={[
        'header',
        window.sidebarOpen ? 'header-slidein' : 'header-slideout',
      ].join(' ')}
    >
      <div
        id="fs-header-burger-button"
        onClick={burgerButtonHandler}
        tabIndex="2"
        onKeyPress={(evt) => {
          if (evt.key === 'Enter') {
            burgerButtonHandler();
          }
        }}
      >
        <BurgerMenuIcon style={{ height: '16px', marginTop: '10px' }} />
      </div>

      <div id="fs-header-bar-button">
        <img src={require('./images/bar-button.png')} alt="Header Logo" />
      </div>
    </div>
  );
};
export default Header;
